import React from "react";

interface NoDataCreatedProps {
    message: string;
    containerClassname?: string;
}

const NoDataCreated: React.FC<NoDataCreatedProps> = ({ message, containerClassname }) => {
    return (
        <div className={`no_data_created_area ${containerClassname}`}>
            <img src="/assets/images/no_data/no_data_img.png" alt="No Data Found!" />
            <h6>{message}</h6>
        </div>
    )
}

export default NoDataCreated;